export const convertOrderMessage = (data: any) => {
  return {
    messages: data?.messages?.map((mes: any) => {
      return {
        id: mes?.id,
        imageUser: 'https://i.ibb.co/2Y9dxH2/user-01.png',
        alt: mes?.user.email ?? '',
        name: mes?.user.name ?? mes?.admin.name,
        admin: mes?.admin,
        time: mes?.createdAt ?? '',
        description: mes?.message ?? '',
        imageComment: mes?.files?.map((file: { url: string; filename: string }) => {
          return {
            src: file?.url ?? '',
            alt: file?.filename ?? '',
          }
        }),
        isUnread: mes?.isUnread,
        statusChangedFrom: mes?.statusChangedFrom,
        statusChangedTo: mes?.statusChangedTo,
      }
    }),
  }
}
